// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import axios from 'axios'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant, {Toast} from 'vant'
import 'vant/lib/index.css'
// import 'vant/lib/index.less'
import 'font-awesome/css/font-awesome.css'
import VueClipboard from 'vue-clipboard2'
import '@/card/init'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
axios.defaults.baseURL = '/'
Vue.use(Toast)
Vue.use(Vant)
Vue.use(VueClipboard)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js